module.exports = __webpack_public_path__ + "img/noCont.fe3d2c14.png";